import {
  setupFeatures,
  getFeatureLoader,
  isFeatureEnabled,
  ExecutionEnvironment
} from "@origin-digital/features";
import {
  isLocalEnvironment,
  decodeOriginCustomerIdFromJwt
} from "../../auth/jwtUtils";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { fetchAccessToken } from "@origin-digital/event-dispatcher";

const FEATURE_TOGGLE_SAC_V2 = "sales-lpg-in-myaccount";

const getJwt = async (envName: EnvironmentNames) => {
  let jwt;
  try {
    jwt = await fetchAccessToken({
      environment: envName
    });
  } catch (error) {
    return undefined;
  }
  return jwt;
};

export const getOriginCustomerId = async () => {
  let jwt = await getJwt(window.oetal.env.name as EnvironmentNames);
  if (!jwt) {
    return undefined;
  }
  return decodeOriginCustomerIdFromJwt(jwt.accessToken);
};

export const initFeatures = (
  originCustomerId: string | undefined,
  featureCallback: (featureEnabled: boolean) => void
) => {
  setupFeatures({
    environment: window.oetal.env.name as ExecutionEnvironment,
    defaultFeatureValue: false,
    localMode: isLocalEnvironment()
      ? {
          features: {
            [FEATURE_TOGGLE_SAC_V2]: false
          }
        }
      : undefined
  });
  getFeatureLoader().addFeatureListener(() => {
    const featureEnabled = isFeatureEnabled(FEATURE_TOGGLE_SAC_V2, {
      originCustomerId: originCustomerId
    });
    featureCallback(featureEnabled);
  });
};
